import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Dropdown, Badge, Button } from 'react-bootstrap';
import ProfileModal from './ProfileViewModal';
import NotificationDropdown from './NotificationDropdown';

interface HeaderProps {
  onToggleSidebar: () => void;
  user: any;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar, user }) => {
  const { logout } = useAuth();
  const [showProfileModal, setShowProfileModal] = useState(false);

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="header">
      <div className="d-flex align-items-center">
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={onToggleSidebar}
          className="me-3"
        >
          <i className="bi-list"></i>
        </Button>

        <div className="d-flex align-items-center">
          <h5 className="mb-0 me-3">Admin Panel</h5>
          <Badge bg="primary" className="d-none d-md-inline">
            v1.0.0
          </Badge>
        </div>
      </div>

      <div className="d-flex align-items-center gap-2">
        {/* Notification Bell */}
        <NotificationDropdown />

        {/* User Menu */}
        <Dropdown>
          <Dropdown.Toggle
            variant="outline-secondary"
            size="sm"
            className="d-flex align-items-center"
          >
            <div className="me-2">
              <div
                className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: '32px', height: '32px', fontSize: '0.875rem' }}
              >
                {user?.name?.charAt(0).toUpperCase() || 'A'}
              </div>
            </div>
            <div className="d-none d-md-block text-start">
              <div className="fw-medium" style={{ fontSize: '0.875rem' }}>
                {user?.name || 'Admin'}
              </div>
              <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                {user?.role || 'Administrator'}
              </small>
            </div>
            <i className="bi-chevron-down ms-2"></i>
          </Dropdown.Toggle>
          
          <Dropdown.Menu align="end">
            <Dropdown.Header>
              <div className="fw-medium">{user?.name || 'Admin User'}</div>
              <small className="text-muted">{user?.email || 'admin@mycinemas.com'}</small>
            </Dropdown.Header>
            
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => setShowProfileModal(true)}>
              <i className="bi-person me-2"></i>
              Profile
            </Dropdown.Item>

            
            {/* <Dropdown.Item>
              <i className="bi-gear me-2"></i>
              Settings
            </Dropdown.Item>
            
            <Dropdown.Item>
              <i className="bi-question-circle me-2"></i>
              Help & Support
            </Dropdown.Item> */}
            
            <Dropdown.Divider />
            
            <Dropdown.Item onClick={handleLogout} className="text-danger">
              <i className="bi-box-arrow-right me-2"></i>
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <ProfileModal
  show={showProfileModal}
  onHide={() => setShowProfileModal(false)}
  user={user}
/>

    </header>
  );
};

export default Header;
